import { createContext, FC, ReactNode, useContext, useEffect, useMemo, useState } from 'react'

import { fetchAdmins } from '@/hooks/useElectionsServer'

type WithChildren = {
  children?: ReactNode
}

type AdminsContextType = {
  isLoading: boolean
  admins: string[]
}

export const AdminsContext = createContext<AdminsContextType>({
  isLoading: false,
  admins: [],
})

export const AdminsProvider: FC<WithChildren> = ({ children }) => {
  const [admins, setAdmins] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  useEffect(() => {
    // fetch admins from server
    const checkAdmins = async () => {
      setIsLoading(true)
      try {
        const fetchedAdmins = await fetchAdmins()
        setAdmins(fetchedAdmins)
        setIsLoading(false)
      } catch (e) {
        setAdmins([])
        setIsLoading(false)
      }
    }
    checkAdmins()
  }, [])

  const contextValue = useMemo(
    () => ({
      isLoading,
      admins,
    }),
    [admins]
  )

  return <AdminsContext.Provider value={contextValue}>{children}</AdminsContext.Provider>
}

export const useAdminsContext = () => useContext(AdminsContext)
